import styled from '@emotion/styled';

export default styled('div')`
	width: 100%;
	margin: 0 auto;
`;
